module.exports = __webpack_public_path__ + "img/car_18.62f167a3.jpg";